import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Dispatch, Icons, LocationService, MapComponent, MapMarker, MapPosition, MessageService, MixinRoot, VehicleMapItem, VehicleService } from 'orv-ui-base-lib';
import { Subscription } from 'rxjs';

import { DataRefresh } from '../data-refresh/data-refresh';


const DELTA = 100000;

@Component({
	selector: 'app-dispatch-map',
	templateUrl: './dispatch-map.component.html',
	styleUrls: ['./dispatch-map.component.scss']
})
export class DispatchMapComponent extends DataRefresh(MixinRoot) implements OnInit, OnDestroy {

	@Input()
	dispatch: Dispatch;

	@ViewChild('map') map: MapComponent;

	loading: boolean = false;
	locations: any[] = [];
	polyline: MapPosition[];
	markers: MapMarker[];
	firsttime: boolean = true;
	start: number = 0;
	stop: number = DELTA;
	locationsSubscription: Subscription;
	vehicleMapItem: VehicleMapItem;
	zoomed: boolean;



	constructor(private cdr: ChangeDetectorRef,
		private messageService: MessageService,
		private translateService: TranslateService,
		private locationService: LocationService, private vehicleService: VehicleService) { super(); }

	ngOnInit() {
		this.refreshData();
		this.init(10000);
	}

	ngOnDestroy() {
		if (this.locationsSubscription) {
			this.locationsSubscription.unsubscribe();
		}
		this.cancelRefresh();
		this.cdr.detach();
		this.destroy();
	}

	refreshData() {
		this.loadLocations();
	}

	loadLocations() {
		if (this.firsttime) {
			this.loading = true;
		}
		this.locationsSubscription = this.locationService.getLocationsByDispatch(this.dispatch.id, this.start, this.stop).subscribe(locations => {
			this.locations = [...this.locations, ...locations];
			this.polyline = this.locations;
			this.start = this.locations.length;
			this.stop = this.start + DELTA;
			if (locations.length) {
				const startMarker: MapMarker = {
					id: 1,
					lat: this.dispatch.startinglat,
					lng: this.dispatch.startinglng,
					icon: Icons.STARTICON
				};

				const physicalStart: MapMarker = {
					id: 2,
					lat: this.dispatch.physicalstartlat,
					lng: this.dispatch.physicalstartlng,
					icon: Icons.PHYSICALSTART,
				};

				// const lastIndex = this.locations.length - 1;
				// const endMarker: MapMarker = {
				// 	id: this.locations[lastIndex].id,
				// 	lat: this.locations[lastIndex].lat,
				// 	lng: this.locations[lastIndex].lng,
				// 	icon: Icons.ENDICON
				// };
				// const physicalEnd: MapMarker = {
				// 	id: this.locations[lastIndex].id + 1,
				// 	lat: this.dispatch.stoplat,
				// 	lng: this.dispatch.stoplng,
				// 	icon: Icons.PHYSICALEND
				// };
				if (this.map) {
					if (this.dispatch.isStatusOnRide)
						this.loadVehiclePosition();
					else if (!this.zoomed) {
						this.zoomed = true;
						setTimeout(() => {
							this.map.zoomToMarkers([startMarker, physicalStart], 12, 12, false);
						}, 1000);
					}
				}
				this.markers = [startMarker, physicalStart];

			}
			this.loading = false;
			this.firsttime = false;
			this.cdr.detectChanges();

			if (this.dispatch.isStatusOnRide) super.refreshData();
		}, ({ error }) => {
			this.messageService.sendError(error.msg, this.translateService.instant('labels.dispatch'));
			this.loading = false;
		});
	}

	onMapReady(event: any) {
		if (this.dispatch.isStatusOnRide) {
			this.loadVehiclePosition();
		} else if (!this.zoomed) {
			this.zoomed = true;
			setTimeout(() => {
				this.map.zoomToMarkers(this.markers, 12, 12, false);
			}, 1000);
		}
	}


	loadVehiclePosition() {
		if (this.dispatch && this.dispatch.vehicle && this.dispatch.vehicle.fleetcode) {
			this.vehicleService.getMapById(this.dispatch.vehicle.id).subscribe(items => {
				if (items && items.length && this.map) {
					const v: VehicleMapItem = items[0];
					v.truckicon = true;
					if (this.vehicleMapItem) {
						this.map.updateMarker(v);
					} else {
						this.map.addMarker(v);
						if (!this.zoomed) {
							this.zoomed = true;
							setTimeout(() => {
								this.map.zoomToMarkers([v], 12, 12, false);
							}, 1000);
						}
					}



				}
			});
		}
	}


}
